import Http from "../../http/client";
import { RequestQueryBuilder } from "@nestjsx/crud-request";

export default async ({name, surname, phoneNumber, isReady, group, fields, perPage, page}) => {
  const qb = RequestQueryBuilder.create();

  if(name) { qb.setFilter({ field: "name", operator: "$startsL", value: name }) }
  if(surname) { qb.setFilter({ field: "surname", operator: "$startsL", value: surname }) }
  if(phoneNumber) { qb.setFilter({ field: "phoneNumber", operator: "$eq", value: phoneNumber }) }
  if(isReady) { qb.setFilter({ field: "isReady", operator: "$eq", value: isReady }) }
  if(group) { qb.setFilter({ field: "groups.id", operator: "$eq", value: group }) }

  qb.sortBy({field: 'createdAt', order: "DESC"});

  if (page && perPage) {
    qb.setPage(page);
    qb.setLimit(perPage);
    qb.setOffset(perPage * page);
  }
  qb.setJoin({field: 'groups', select: ['id', 'title']});
  qb.select(fields);

  const response = await Http.get('admin/users', {
    params: qb.queryObject
  });

  return response.data;
}
